/* Smart søk for 123 Auto Guides (14. sept. 2026).
   Treff mens du skriver i søkefeltet i toppmenyen og på søkesida, gruppert i
   bilhjelp, varsellamper, feilkoder, guider, sider og nyheter. Leser
   sokeindeks-nb.json / sokeindeks-en.json (tools/sok/lag_sokeindeks.py).
   Synonymer på tvers av språk, feilkoder med og uten P, tåler små skrivefeil. */
(function () {
  if (window.__smartSok) return;
  window.__smartSok = true;

  var oppsett = document.getElementById('smart-sok-oppsett');
  if (!oppsett) return;
  var CFG;
  try { CFG = JSON.parse(oppsett.textContent); } catch (e) { return; }
  var NB = CFG.sprak === 'nb';

  var TX = NB ? {
    pop: 'Populære søk', alle: 'Se alle resultater for «{q}»', ingen: 'Ingen treff på «{q}». Prøv et av disse:',
    naer: 'Ingen guide passer alle ordene. Nærmeste treff:', laster: 'Laster søket …', beste: 'Beste treff',
    grupper: { hjelp: 'Bilhjelp', lampe: 'Varsellamper', kode: 'Feilkoder', guide: 'Guider', side: 'Sider og temaer', nyhet: 'Nyheter' }
  } : {
    pop: 'Popular searches', alle: 'See all results for “{q}”', ingen: 'Nothing matches “{q}”. Try one of these:',
    naer: 'No guide matches every word. Closest matches:', laster: 'Loading search …', beste: 'Best matches',
    grupper: { hjelp: 'Car help', lampe: 'Warning lights', kode: 'Fault codes', guide: 'Guides', side: 'Pages and topics', nyhet: 'News' }
  };
  var POP = NB ? ['Motorlampe', 'Bilen starter ikke', 'P0300', 'Bremser', 'Elbil', 'AdBlue', 'EU-kontroll', 'Hybrid']
               : ['Check engine light', "Car won't start", 'P0300', 'Brakes', 'EV battery', 'Overheating', 'Used car', 'Hybrid'];

  // Synonymgrupper på tvers av språk. Ord med mellomrom er uttrykk.
  var SYN = [
    ['motorlampe', 'motorlampa', 'motorlys', 'check engine', 'engine light', 'cel', 'mil'],
    ['bremse', 'brems', 'bremser', 'bremsene', 'brake', 'brakes', 'braking', 'bremsing', 'klosser', 'bremseklosser', 'pads', 'skiver', 'rotors', 'rotor', 'discs'],
    ['batteri', 'batteriet', 'battery', 'startbatteri', '12v'],
    ['elbil', 'elbilen', 'ev', 'electric', 'elektrisk'],
    ['hybrid', 'hybridbil', 'phev'],
    ['bensin', 'petrol', 'gasoline', 'fuel', 'drivstoff'],
    ['olje', 'oljen', 'oil', 'oljelampe'],
    ['kjolevaeske', 'coolant', 'antifreeze', 'frostvaeske', 'kjolesystem', 'cooling'],
    ['overoppheting', 'overheating', 'overheat', 'varm', 'temperatur', 'temperature', 'hot'],
    ['dekk', 'dekkene', 'tire', 'tires', 'tyre', 'tyres', 'dekktrykk'],
    ['starter', 'start', 'starte', 'starting'],
    ['fusker', 'fuske', 'misfire', 'misfiring', 'feiltenning', 'tenningsfeil'],
    ['rister', 'risting', 'shake', 'shakes', 'shaking', 'vibration', 'vibrerer'],
    ['bruktbil', 'used car', 'bruktbiler'],
    ['eu kontroll', 'eu-kontroll', 'eukontroll', 'pkk', 'inspection'],
    ['feilkode', 'feilkoder', 'kode', 'koder', 'code', 'codes', 'obd', 'obd2', 'obd ii', 'dtc'],
    ['varsellampe', 'varsellamper', 'varsellys', 'warning light', 'warning lights', 'dashboard', 'lampe', 'symbol'],
    ['adblue', 'def'],
    ['dpf', 'partikkelfilter', 'particulate'],
    ['gloedeplugg', 'glodeplugg', 'gloeplugg', 'glow plug', 'glow plugs', 'forvarming', 'preheat'],
    ['servostyring', 'power steering', 'styring', 'steering'],
    ['clutch', 'clutchen', 'kobling'],
    ['lading', 'lade', 'charging', 'charger', 'lader'],
    ['dyse', 'dyser', 'injector', 'injectors', 'innsproyting', 'injection'],
    ['airbag', 'srs', 'kollisjonspute'],
    ['esp', 'traction', 'antispinn', 'esc', 'antiskrens'],
    ['lukt', 'lukter', 'smell', 'smells'],
    ['royk', 'smoke', 'eksos', 'exhaust'],
    ['vinter', 'winter', 'kulde', 'cold', 'kaldt', 'kald'],
    ['vedlikehold', 'maintenance', 'service'],
    ['girkasse', 'gear', 'gearbox', 'transmission', 'gir'],
    ['lyd', 'lyder', 'noise', 'noises', 'sound', 'klikk', 'klikker', 'clicking', 'hyler', 'squeal', 'squealing'],
    ['lekker', 'lekkasje', 'leak', 'leaking', 'mister', 'losing'],
    ['kjopt', 'kjope', 'kjop', 'buy', 'buying', 'purchase'],
    ['gratis', 'free', 'sjekkliste', 'checklist']
  ];

  function norm(s) {
    s = String(s || '').toLowerCase().replace(/æ/g, 'ae').replace(/ø/g, 'o').replace(/å/g, 'a');
    if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return s.replace(/['’]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  var SYNG = SYN.map(function (g) { return g.map(norm); });

  function utvid(q) {
    var s = ' ' + norm(q) + ' ', ekstra = [];
    SYNG.forEach(function (g) {
      g.forEach(function (m) {
        if (m.indexOf(' ') > -1 && s.indexOf(' ' + m + ' ') > -1) {
          s = s.replace(' ' + m + ' ', ' ');
          var enkle = g.filter(function (x) { return x.indexOf(' ') < 0; });
          if (enkle.length) ekstra.push({ t: m, alt: enkle.concat([m.split(' ').join('')]) });
        }
      });
    });
    var toks = s.trim() ? s.trim().split(/\s+/) : [];
    var ut = toks.map(function (t) {
      var alt = [t];
      if (/^\d{3,4}$/.test(t)) alt.push('p' + (t.length === 3 ? '0' + t : t));
      if (/^p\d{3}$/.test(t)) alt.push('p0' + t.slice(1));
      // Korte ord (ev, abs) utvides bare naar de er et helt synonym, ellers blir «ev» til «evap».
      SYNG.forEach(function (g) {
        var treff = g.some(function (m) {
          return m.indexOf(' ') < 0 && (m === t || (t.length >= 4 && m.indexOf(t) === 0) || (t.length >= 3 && m.length >= 4 && t.indexOf(m) === 0 && t.length - m.length <= 3));
        });
        if (treff) g.forEach(function (m) { if (m.indexOf(' ') < 0 && alt.indexOf(m) < 0) alt.push(m); });
      });
      return { t: t, alt: alt };
    });
    return ut.concat(ekstra);
  }

  function lev(a, b, maks) {
    if (Math.abs(a.length - b.length) > maks) return maks + 1;
    var v = [], i, j;
    for (j = 0; j <= b.length; j++) v[j] = j;
    for (i = 1; i <= a.length; i++) {
      var p = v[0], min;
      v[0] = i; min = i;
      for (j = 1; j <= b.length; j++) {
        var tmp = v[j];
        v[j] = Math.min(v[j] + 1, v[j - 1] + 1, p + (a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1));
        p = tmp;
        if (v[j] < min) min = v[j];
      }
      if (min > maks) return maks + 1;
    }
    return v[b.length];
  }

  function ordTreff(alt, ord, fuzzy) {
    var best = 0;
    for (var i = 0; i < ord.length; i++) {
      var w = ord[i];
      if (w === alt) return 1;
      if (w.indexOf(alt) === 0) { best = Math.max(best, alt.length >= 3 ? 0.9 : 0.55); continue; }
      if (alt.length >= 4 && w.length >= 3 && alt.indexOf(w) === 0 && alt.length - w.length <= 2) { best = Math.max(best, 0.8); continue; }
      if (fuzzy && best < 0.5 && alt.length >= 4 && !/\d/.test(alt)) {
        var maks = alt.length >= 7 ? 2 : 1;
        if (lev(alt, w, maks) <= maks || (w.length > alt.length && lev(alt, w.slice(0, alt.length), maks) <= maks)) best = 0.5;
      }
    }
    return best;
  }

  function har(ord, alt) { return ord.indexOf(alt) > -1 ? 1 : 0; }

  var DOKS = null, lasting = null;
  var BONUS = { hjelp: 1.5, lampe: 1.5, kode: 1.5, guide: 1, side: 0.5, nyhet: 0 };

  function last() {
    if (DOKS) return Promise.resolve(DOKS);
    if (lasting) return lasting;
    lasting = fetch(CFG.indeks, { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (j) {
      DOKS = j.d.map(function (d) {
        d.TN = norm(d.t);
        d.T = d.TN.split(' ');
        d.K = norm(d.n).split(' ');
        d.S = norm(d.s).split(' ');
        d.X = norm(d.x).split(' ');
        return d;
      });
      return DOKS;
    });
    return lasting;
  }

  function poeng(d, toks, qn) {
    var sum = 0, mangler = 0;
    for (var i = 0; i < toks.length; i++) {
      var tb = 0;
      for (var a = 0; a < toks[i].alt.length && tb < 10; a++) {
        var alt = toks[i].alt[a], f = a === 0 ? 1 : 0.75;
        // Korte synonymer (ev, def, srs) maa treffe hele ord, ellers treffer «def» «defekt».
        var s = ((a > 0 && alt.length <= 3) || (alt.length <= 2 && toks[i].alt.length > 1)
          ? Math.max(har(d.T, alt) * 10, har(d.K, alt) * 6, har(d.S, alt) * 3, har(d.X, alt) * 1.5)
          : Math.max(ordTreff(alt, d.T, true) * 10, ordTreff(alt, d.K, true) * 6, ordTreff(alt, d.S, false) * 3, ordTreff(alt, d.X, false) * 1.5)) * f;
        if (s > tb) tb = s;
      }
      if (tb === 0) mangler++;
      sum += tb;
    }
    if (sum === 0) return { p: 0, m: mangler };
    if (qn.length > 2 && d.TN.indexOf(qn) > -1) sum += 12;
    if (d.TN.indexOf(qn) === 0) sum += 4;
    return { p: sum + (BONUS[d.g] || 0), m: mangler };
  }

  function sok(q) {
    var qn = norm(q);
    if (!qn || !DOKS) return { liste: [], naer: false };
    var toks = utvid(q), hele = [], delvis = [];
    DOKS.forEach(function (d) {
      var r = poeng(d, toks, qn);
      if (r.p <= 0) return;
      if (r.m === 0) hele.push({ d: d, p: r.p });
      else if (toks.length > 1 && r.m < toks.length) delvis.push({ d: d, p: r.p * (1 - r.m / toks.length) });
    });
    var liste = hele, naer = false;
    if (!hele.length && delvis.length) { liste = delvis; naer = true; }
    liste.sort(function (a, b) { return b.p - a.p; });
    return { liste: liste, naer: naer, toks: toks };
  }

  function merk(el, tekst, toks) {
    var biter = String(tekst).split(/(\s+)/);
    biter.forEach(function (b) {
      var n = norm(b);
      var ja = n && toks.some(function (t) {
        return t.alt.some(function (a, ai) {
          return n.split(' ').some(function (w) {
            if (w === a) return true;
            if (ai > 0 && a.length <= 3) return false;
            if (a.length >= 2 && w.indexOf(a) === 0) return true;
            return a.length >= 4 && w.length >= 3 && a.indexOf(w) === 0 && a.length - w.length <= 2;
          });
        });
      });
      if (ja) { var m = document.createElement('mark'); m.textContent = b; el.appendChild(m); }
      else el.appendChild(document.createTextNode(b));
    });
  }

  function rad(d, toks) {
    var a = document.createElement('a');
    a.className = 'ss-rad' + (d.f ? ' ss-' + d.f : '');
    a.href = d.u;
    a.setAttribute('role', 'option');
    var ik = document.createElement('span');
    ik.className = 'ss-ikon' + (d.g === 'guide' || d.g === 'nyhet' || d.g === 'side' ? ' ss-bilde' : '');
    if (d.b) {
      var im = document.createElement('img');
      im.src = d.b; im.alt = ''; im.width = 44; im.height = 44; im.loading = 'lazy';
      ik.appendChild(im);
    } else {
      ik.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path fill="currentColor" d="M4 4h10l6 6v10H4V4zm9 1.5V11h5.5L13 5.5z"/></svg>';
    }
    a.appendChild(ik);
    var tx = document.createElement('span');
    tx.className = 'ss-tekst';
    var b = document.createElement('b');
    merk(b, d.t, toks || []);
    tx.appendChild(b);
    var sm = document.createElement('small');
    sm.textContent = [d.k, d.s].filter(Boolean).join(' · ');
    tx.appendChild(sm);
    a.appendChild(tx);
    return a;
  }

  function tittel(tekst) {
    var p = document.createElement('p');
    p.className = 'ss-tittel';
    p.textContent = tekst;
    return p;
  }

  function grupper(liste, perGruppe, totalt) {
    var orden = [], kart = {}, n = 0;
    liste.forEach(function (x) {
      if (n >= totalt) return;
      var g = x.d.g;
      if (!kart[g]) { kart[g] = []; orden.push(g); }
      if (kart[g].length < perGruppe) { kart[g].push(x.d); n++; }
    });
    return orden.map(function (g) { return { g: g, doks: kart[g] }; });
  }

  function alleLenke(q) {
    return CFG.sok + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
  }

  var TELL = 0;
  function Panel(inp) {
    var self = this;
    this.inp = inp;
    this.form = inp.form;
    var felt = inp.closest('.field') || inp.parentNode;
    this.el = document.createElement('div');
    this.el.className = 'ss-panel';
    this.el.hidden = true;
    this.el.id = 'ss-panel-' + (++TELL);
    this.el.setAttribute('role', 'listbox');
    felt.parentNode.insertBefore(this.el, felt.nextSibling);
    inp.setAttribute('autocomplete', 'off');
    inp.setAttribute('aria-controls', this.el.id);
    inp.setAttribute('aria-autocomplete', 'list');
    this.aktiv = -1;
    var tid = null;
    inp.addEventListener('input', function () { clearTimeout(tid); tid = setTimeout(function () { self.vis(); }, 40); });
    inp.addEventListener('focus', function () { self.vis(); });
    inp.addEventListener('keydown', function (e) { self.tast(e); });
    document.addEventListener('click', function (e) { if (!self.form.contains(e.target)) self.skjul(); });
  }
  Panel.prototype.skjul = function () { this.el.hidden = true; this.aktiv = -1; };
  Panel.prototype.valg = function () { return [].slice.call(this.el.querySelectorAll('.ss-rad, .ss-chip, .ss-alle')); };
  Panel.prototype.marker = function (i) {
    var v = this.valg();
    v.forEach(function (x, j) { x.classList.toggle('ss-aktiv', j === i); x.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
    this.aktiv = i;
    if (v[i]) v[i].scrollIntoView({ block: 'nearest' });
  };
  Panel.prototype.tast = function (e) {
    if (this.el.hidden) return;
    var v = this.valg();
    if (e.key === 'ArrowDown') { e.preventDefault(); this.marker(Math.min(this.aktiv + 1, v.length - 1)); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); this.marker(Math.max(this.aktiv - 1, -1)); }
    else if (e.key === 'Enter' && this.aktiv > -1 && v[this.aktiv]) { e.preventDefault(); v[this.aktiv].click(); }
    else if (e.key === 'Escape') { this.skjul(); }
  };
  Panel.prototype.chips = function (forelder) {
    var self = this, boks = document.createElement('div');
    boks.className = 'ss-chips';
    POP.forEach(function (ord) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'ss-chip'; b.textContent = ord;
      b.addEventListener('click', function (e) { e.preventDefault(); self.inp.value = ord; self.inp.focus(); self.vis(); });
      boks.appendChild(b);
    });
    forelder.appendChild(boks);
  };
  Panel.prototype.vis = function () {
    var self = this, q = this.inp.value.trim(), el = this.el;
    this.aktiv = -1;
    if (!DOKS) {
      el.innerHTML = '';
      el.appendChild(tittel(TX.laster));
      el.hidden = false;
      last().then(function () { if (document.activeElement === self.inp || self.inp.value) self.vis(); }).catch(function () { self.skjul(); });
      return;
    }
    el.innerHTML = '';
    if (!q) {
      el.appendChild(tittel(TX.pop));
      this.chips(el);
      el.hidden = false;
      return;
    }
    var r = sok(q);
    if (!r.liste.length) {
      var p = document.createElement('p');
      p.className = 'ss-melding';
      p.textContent = TX.ingen.replace('{q}', q);
      el.appendChild(p);
      this.chips(el);
    } else {
      if (r.naer) {
        var n = document.createElement('p');
        n.className = 'ss-melding';
        n.textContent = TX.naer;
        el.appendChild(n);
      }
      grupper(r.liste, 5, 14).forEach(function (gr) {
        var boks = document.createElement('div');
        boks.className = 'ss-gruppe';
        boks.appendChild(tittel(TX.grupper[gr.g] || gr.g));
        gr.doks.forEach(function (d) { boks.appendChild(rad(d, r.toks)); });
        el.appendChild(boks);
      });
    }
    var alle = document.createElement('a');
    alle.className = 'ss-alle';
    alle.href = alleLenke(q);
    alle.textContent = TX.alle.replace('{q}', q) + ' →';
    el.appendChild(alle);
    el.hidden = false;
  };

  function beste() {
    var boks = document.querySelector('[data-smart-beste]');
    if (!boks) return;
    var q = boks.getAttribute('data-q') || '';
    if (!q.trim()) return;
    last().then(function () {
      var r = sok(q);
      if (!r.liste.length) return;
      var panel = document.createElement('div');
      panel.className = 'ss-panel ss-statisk';
      panel.appendChild(tittel(TX.beste));
      grupper(r.liste, 4, 12).forEach(function (gr) {
        var g = document.createElement('div');
        g.className = 'ss-gruppe';
        g.appendChild(tittel(TX.grupper[gr.g] || gr.g));
        gr.doks.forEach(function (d) { g.appendChild(rad(d, r.toks)); });
        panel.appendChild(g);
      });
      boks.appendChild(panel);
    }).catch(function () {});
  }

  function start() {
    [].forEach.call(document.querySelectorAll('form[role="search"] input[name="q"]'), function (inp) {
      if (inp.__ss) return;
      inp.__ss = new Panel(inp);
    });
    beste();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.smartSok = { sok: function (q) { return last().then(function () { return sok(q); }); }, norm: norm };
})();
